import http from '../httpService';
import { Availability, CreateAvailability, PagedAvailability } from './dto/availability';

class AvailabilityService {
  public async createOrUpdate(request: CreateAvailability[]) {
    const result = await http.post('api/services/app/Availability/CreateAvailabilites', request);
    return result.data.result;
  }

  public async getAvailabilities(request: PagedAvailability): Promise<Availability[]> {
    const result = await http.get('api/services/app/Availability/GetAvailabilities', {
      params: request,
    });
    return result.data.result;
  }
}

export default new AvailabilityService();
